import exp from 'constants'
import React from 'react'
import Notice from './notice';
import Contents from './contents';
import Postbox from './post-box';

function Mainpage() {
  return (
    <div>
      <div className='title-box'>
          <h1 className='maintitle'>마리엘 콘텐츠 기록소</h1>
        </div>
        <div className='main-postbox'>
        <Postbox />
        </div>
    </div>
  )
}

export default Mainpage;
